<template>
  <div>
    <v-row align="center" justify="end" class="my-1">
      <v-col cols="12" sm="6">
        <v-text-field
          hide-details
          single-line
          clearable
          solo
          append-icon="fa-search"
          v-model="search"
        ></v-text-field> </v-col
    ></v-row>
    <v-card>
      <v-card-title>
        # sans catégorie
      </v-card-title>
      <v-card-text>
        <v-row align="center" class="my-2" no-gutters>
          <draggable
            tag="div"
            v-model="tagsModel"
            group="tag"
            class="drag-zone"
          >
            <v-chip
              outlined
              v-for="(tag, index) in tags"
              :key="index"
              v-show="
                search === '' ||
                  search === null ||
                  tag.toLowerCase().includes(search.toLowerCase())
              "
            >
              {{ tag }}
            </v-chip>
          </draggable>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card
      class="my-2"
      v-for="(category, index) in getTagCategories"
      :key="category.id"
    >
      <v-card-title>
        <v-row align="start" justify="space-between" dense>
          <v-col align-self="start">
            <v-row dense no-gutters
              ><span class="title">{{ category.name }}</span>
            </v-row>
            <span class="caption" v-if="category.category_type !== 0">
              {{ getTagCategoryName(category.category_type) }}</span
            >
          </v-col>
          <v-col cols="4">
            <v-row align="center" justify="end" no-gutters>
              <TagManagerTagAdder :item="category"></TagManagerTagAdder>
              <TagManagerEditor
                class="ml-1"
                :id="category.id"
                @update="() => $emit('update')"
              ></TagManagerEditor>
              <v-btn class="ml-1" small icon @click="deleteTags(category)">
                <v-icon small>fa-trash</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row align="center">
          <v-col style="flex-shrink: 1; flex-grow: 0;">
            <v-row align="center" no-gutters>
              <v-btn
                icon
                small
                @click="upArrow(category, index)"
                v-show="index !== 0"
              >
                <v-icon small>fa-chevron-up</v-icon>
              </v-btn>
            </v-row>
            <v-row align="center" no-gutters>
              <v-btn
                icon
                small
                @click="downArrow(category, index)"
                v-show="index !== getTagCategories.length - 1"
              >
                <v-icon small>fa-chevron-down</v-icon>
              </v-btn>
            </v-row>
          </v-col>
          <v-col style="flex-shrink: 0; flex-grow: 1;">
            <draggable
              v-model="category.tags"
              group="tag"
              class="drag-zone"
              @change="updateTags(category)"
            >
              <v-chip
                outlined
                v-for="(tag, index) in category.tags"
                :key="index"
                v-show="
                  search === '' ||
                    search === null ||
                    tag.toLowerCase().includes(search.toLowerCase())
                "
              >
                {{ tag }}
              </v-chip>
            </draggable>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import TagManagerEditor from "./TagManagerEditor";
import TagManagerTagAdder from "./TagManagerTagAdder";
import { mapGetters } from "vuex";
import { api } from "@/api";
export default {
  name: "TagManagerList",
  components: {
    draggable,
    TagManagerEditor,
    TagManagerTagAdder
  },
  props: {
    tags: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getTagCategories", "getTagCategoryTypes"]),
    tagsModel: {
      get() {
        return this.tags;
      },
      set(value) {
        this.$emit("update:tags", value);
      }
    }
  },
  data() {
    return {
      search: ""
    };
  },
  methods: {
    async updateTags(item) {
      const res = await api.patchTagCategory(item.id, item);
      item = res;
    },
    async deleteTags(item) {
      const confirm = await this.$dialog.confirm({
        text: "Voulez-vous vraiment supprimer cette catégorie?",
        title: "Suppression de catégorie"
      });
      if (confirm) {
        await api.deleteTagCategory(item.id);
        this.$emit("update");
      }
    },
    async upArrow(item, index) {
      if (index !== 0) {
        try {
          this.$store.dispatch("slo");
          const up = {
            ...this.item,
            display_order: index - 1
          };
          const down = {
            ...this.getTagCategories[index - 1],
            display_order: index + 1
          };
          await Promise.all([
            api.patchTagCategory(item.id, up),
            api.patchTagCategory(down.id, down)
          ]);
          await this.$store.dispatch("loadTagCategories");
        } finally {
          this.$store.dispatch("elo");
        }
      }
    },
    async downArrow(item, index) {
      if (index !== this.getTagCategories.length - 1) {
        try {
          this.$store.dispatch("slo");
          const up = {
            ...this.item,
            display_order: index + 1
          };
          const down = {
            ...this.getTagCategories[index + 1],
            display_order: index - 1
          };
          await Promise.all([
            api.patchTagCategory(item.id, up),
            api.patchTagCategory(down.id, down)
          ]);
          await this.$store.dispatch("loadTagCategories");
        } finally {
          this.$store.dispatch("elo");
        }
      }
    },
    getTagCategoryName(value) {
      const type = this.getTagCategoryTypes.find(x => x.value === value);
      if (type) {
        return type.text;
      } else {
        return "";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.drag-zone {
  width: 100%;
  min-height: 60px;
  padding: 5px;
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.15);
}
</style>
